import { AfterViewInit, ChangeDetectorRef, Component, Input, EventEmitter, TemplateRef, Output } from "@angular/core";
import { Order } from "../../../../../objects/orders/order";
import { OrderItem } from "../../../../../objects/orders/orderItem";
import { BaseResponse } from "../../../../../objects/common/baseResponse";
import { Country } from "../../../../../objects/management/locationManagement/Country";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { ConfigService } from "../../../../../services/configService";
import { CalculatorHelper } from "../../../../../common/helpers/calculatorHelper";
import { GoogleTagService } from "../../../../../services/google-tag.service";
import { WizardComponent } from "ngx-wizard";
import { PageVisit } from "../../../../../objects/pages/pageVisit";

@Component({
    selector: "manufacturer-tab-v2",
    templateUrl: "./manufacturer-tab-v2.component.html",
    moduleId: module.id.toString()
})
export class ManufacturerTabV2Component implements AfterViewInit {

    @Input()
    public order: Order = new Order();
    @Input()
    public orderItem: OrderItem = new OrderItem();

    @Input()
    public wizardComponent: WizardComponent;

    @Input()
    public wizardFooterTemplate: TemplateRef<any>;

    @Input()
    public focusInput: any;
    @Output()
    public onTabSelected: EventEmitter<PageVisit> = new EventEmitter<PageVisit>();

    public get isVehicle(): boolean {
        return CalculatorHelper.isVehicle(this.order);
    }

    constructor(public configService: ConfigService,
                private detectChanges: ChangeDetectorRef,
                public googleTagService: GoogleTagService) {

    }

    public ngAfterViewInit(): void {
        this.initManufacturerSelect();
    }


    public initManufacturerSelect(): void {
        let select = $(`#manufacturerSelect`);

        let self = this;
        select.select2({
            width: '100%',
            data: [],
            allowClear: false,
            placeholder: 'Other country',
            ajax: {
                url: this.configService.config.ApiUrl + "/location/search/country",
                delay: 500,
                headers: {
                    'Authorization': 'Bearer ' + Cookie.get(this.configService.config.ApiTokenCookieName),
                },
                data: function (params: any) {
                    return {
                        country: params.term
                    };
                },
                processResults: function (data: BaseResponse<Country[]>, params: any) {
                    let results: any[] = data.Data.map(function (country) {
                        return {
                            id: country.Code,
                            text: country.Name
                        }
                    });

                    results = results.filter(x => x.text.toLowerCase() != "canada"
                        /*&& x.text.toLowerCase() != "mexico"*/
                        && x.text.toLowerCase() != "united states"
                        && x.text.toLowerCase() != 'japan'
                        && x.text.toLowerCase() != 'china'
                        && x.text.toLowerCase() != 'germany');

                    return {
                        results: results
                    };
                },
            },
            minimumInputLength: 2
        }).on('select2:select', function (e: any) {
            let selectedData = $(this).select2('data');

            let item = selectedData[0];

            self.orderItem.Manufacturer = new Country({
                Code: item.id,
                Name: item.text
            });

        }).on('select2:unselect', function (e: any) {
            self.orderItem.Manufacturer = new Country();
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
    }

    public setManufacturer(country: Country): void {
        if (this.orderItem.Manufacturer && this.orderItem.Manufacturer.Code == country.Code)
            this.orderItem.Manufacturer = new Country();
        else {
            $(`#manufacturerSelect`).html("");
            this.orderItem.Manufacturer = country;
        }

        this.detectChanges.detectChanges();
    }

    public getCountry(code: string): Country {
        let name = '';
        code = code.toUpperCase().trim();

        switch (code) {
            case 'US' :
                name = 'United States';
                break;
            case 'CA' :
                name = 'Canada';
                break;
            case 'CN' :
                name = 'China';
                break;
            case 'JP' :
                name = 'Japan';
                break;
            case 'DE' :
                name = 'Germany';
                break;
        }

        return new Country({
            Code: code,
            Name: name
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/manufacturer-tab/manufacturer-tab-v2.component.ts